export default __webpack_public_path__ + "static/media/pic2.1687bf82.jpeg";